import { useEffect } from 'react'

export const useExternalLinksListener = () => {
  useEffect(() => {
    const listener = (event: MouseEvent) => {
      const target = event.target as HTMLElement

      if (
        target.tagName === 'A' &&
        (target as HTMLAnchorElement).hostname !== window.location.hostname
      ) {
        event.preventDefault()
        window.open(target.getAttribute('href') as string, '_blank')
      }
    }

    document.addEventListener('click', listener)

    return () => {
      document.removeEventListener('click', listener)
    }
  }, [])
}
